import { PAGE_ONE } from "ui/pagination";
import { IPaginationParams } from "ui/pagination/types";

export const columns = ["Admin's Name", "Role", "Status", "Date Added"];

export const DEFAULT_BUSINESS_ADMINS_PAGE_LIMIT = 10;
export const DEFAULT_BUSINESS_ADMINS_PAGINATION_PARAMS: IPaginationParams = {
  page: PAGE_ONE,
  limit: DEFAULT_BUSINESS_ADMINS_PAGE_LIMIT,
};
